import { AppRegistry } from 'react-native';
import { App } from './app-root';

// Registers an app's root component
AppRegistry.registerComponent('App', () => App);
// Loads the JavaScript bundle and runs the app
AppRegistry.runApplication('App', { rootTag: document.getElementById('root') });
